import styled from 'styled-components';

interface Props {
  position?: 'absolute' | 'relative' | 'fixed';
}

export const Wrapper = styled.div<Props>`
  margin: 0 auto;
  display: flex;
  position: ${({ position }) => position || 'absolute'};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  justify-content: center;
  align-items: center;
`;
